import { Image } from "@custom/schema";
import React from "react";
export default function LogosWithText(props) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 mb-12 md:mb-16 lg:mb-24 relative overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl text-center overflow-hidden"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-xl md:text-2xl lg:text-3xl font-medium mb-8"
    }, props.logosHeading), /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:max-w-5xl mx-auto text-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:gap-x-16 md:justify-center"
    }, props.logoItems.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: index,
            className: "flex-1 text-center flex flex-col items-center mb-4 md:mb-0"
        }, item.image && /*#__PURE__*/ React.createElement(Image, {
            source: item.image.source,
            alt: item.image.alt,
            className: "mb-2 !bg-contain bg-no-repeat !max-h-[240px]"
        }), /*#__PURE__*/ React.createElement("h4", {
            className: "text-xl block mb-0.5 font-heading font-semibold"
        }, item.title), item.text && /*#__PURE__*/ React.createElement("p", null, item.text));
    })))))));
}
